import { Scorecard as ScorecardModel, ScorecardResult } from '../../models/Scorecard'
import React from 'react'
import { ClientProfileSection } from './ClientProfileSection'
import { getLabel, ScorecardLabelLevel } from '../../common/clientProfile'
import { Col, Row } from 'react-bootstrap'
import { parseMetadata } from '../../apps/professional-app/fa/MeetingSummary/utils'

interface ClientProfileBlockProps {
  vkey: string
  value: { [key: string]: any }
  scorecard: ScorecardModel
  scorecardResult: ScorecardResult
  schema: object
}

export const ClientProfileBlock: React.FC<ClientProfileBlockProps> = ({ vkey, value, scorecard, scorecardResult, schema }) => {
  const shouldRenderBlockLabel = () => {
    if (!scorecard.metadata) {
      return true
    }
    const metadata = parseMetadata(scorecard.metadata)
    return !(metadata && metadata.labelConfig && metadata.labelConfig[ScorecardLabelLevel.BLOCK] === 'skip')
  }

  return (
    <Row className='gap-2' key={`block.row.${vkey}`}>
      <Col>
        {shouldRenderBlockLabel() && (
          <span className='scorecard-root-property'>{getLabel(scorecard.descriptor, vkey, value, ScorecardLabelLevel.BLOCK, scorecard.metadata)}</span>
        )}
        <ClientProfileSection vkey={vkey} value={value} scorecard={scorecard} scorecardResult={scorecardResult} schema={schema} />
      </Col>
    </Row>
  )
}
